import PropTypes from 'prop-types'

const DemoSvgs = ({ icon, sides = {} }) => {
  const icons = {
    pinkLeft: (
      <svg
        width={466}
        height={921}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          ...sides,
        }}
      >
        <path
          d="M-259.043 575.823a79 79 0 01-78.294 10.537l-394.951-162.265a79.002 79.002 0 01-48.273-62.536l-56.95-423.17a79.002 79.002 0 0130.022-73.074l338.001-260.905a79.002 79.002 0 0178.294-10.537L3.757-243.862a79 79 0 0148.273 62.537l56.95 423.17a79 79 0 01-30.022 73.073l-338.001 260.905z"
          fill="url(#prefix__la)"
        />
        <g
          style={{
            mixBlendMode: 'hard-light',
          }}
          opacity={0.5}
          filter="url(#prefix__lb)"
        >
          <path
            d="M-241.145 360.571a79 79 0 01-78.294 10.537l-263.705-108.343a79 79 0 01-48.272-62.536l-38.025-282.547a79 79 0 0130.022-73.073l225.68-174.204a79 79 0 0178.294-10.537L-71.74-231.789a79 79 0 0148.273 62.536l38.025 282.547a79 79 0 01-30.022 73.073l-225.681 174.204z"
            fill="url(#prefix__lc)"
          />
        </g>
        <defs>
          <linearGradient
            id="prefix__la"
            x1={173.102}
            y1={402.267}
            x2={-870.92}
            y2={495.662}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E70077" />
            <stop offset={0.974} stopColor="#FC8F0C" />
          </linearGradient>
          <linearGradient
            id="prefix__lc"
            x1={-277.25}
            y1={388.441}
            x2={-377.634}
            y2={-357.465}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <filter
            id="prefix__lb"
            x={-998.99}
            y={-688.82}
            width={1343.1}
            height={1408.62}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={50} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation={150}
              result="effect2_foregroundBlur"
            />
          </filter>
        </defs>
      </svg>
    ),
    orangeLeft: (
      <svg
        width={459}
        height={1400}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          ...sides,
        }}
      >
        <path
          d="M-298.375 273.095a52.002 52.002 0 0150.995-10.174L70.597 370.657a51.999 51.999 0 0134.308 39.076l65.687 329.243a52.003 52.003 0 01-16.687 49.25l-252.29 221.504a52 52 0 01-50.995 10.18l-317.976-107.738a51.999 51.999 0 01-34.309-39.076l-65.686-329.243a52 52 0 0116.686-49.25l252.29-221.508z"
          fill="url(#prefix__a)"
        />
        <path
          opacity={0.5}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-511.536 732.632A101.088 101.088 0 00-527.589 810l54.597 273.66a101.078 101.078 0 0066.694 75.96l264.294 89.55a101.079 101.079 0 0099.132-19.78l209.698-184.11c27.138-23.83 39.504-60.324 32.438-95.741l-17.396-87.193a101.026 101.026 0 01-16.385 18.372L-44.214 1064.83a101.08 101.08 0 01-99.133 19.78l-264.294-89.549a101.087 101.087 0 01-66.694-75.963l-37.201-186.466z"
          fill="url(#prefix__b)"
        />
        <g
          style={{
            mixBlendMode: 'hard-light',
          }}
          opacity={0.5}
          filter="url(#prefix__c)"
        >
          <path
            d="M-322.941 456.725a101.087 101.087 0 0199.132-19.777l161.657 54.772a101.085 101.085 0 0166.695 75.962l33.394 167.385A101.085 101.085 0 015.5 830.807L-122.764 943.42a101.084 101.084 0 01-99.132 19.778l-161.657-54.772a101.086 101.086 0 01-66.694-75.962l-33.395-167.386a101.086 101.086 0 0132.439-95.74l128.262-112.613z"
            fill="url(#prefix__d)"
          />
        </g>
        <g
          style={{
            mixBlendMode: 'soft-light',
          }}
          opacity={0.5}
          filter="url(#prefix__e)"
        >
          <path
            d="M-284.565 304.006a48.999 48.999 0 0148.053-9.587l186 63.02a49 49 0 0132.33 36.822L20.24 586.852a49 49 0 01-15.724 46.409L-143.06 762.832a49 49 0 01-48.053 9.587l-186.001-63.02a49 49 0 01-32.329-36.821l-38.424-192.592a49 49 0 0115.724-46.409l147.578-129.571z"
            fill="url(#prefix__f)"
          />
        </g>
        <g
          style={{
            mixBlendMode: 'soft-light',
          }}
          opacity={0.6}
          filter="url(#prefix__g)"
        >
          <path
            d="M-231.846 294.129a46.999 46.999 0 0146.091-9.195l157.358 53.315a47 47 0 0131.01 35.319l32.506 162.933a47 47 0 01-15.082 44.514l-124.852 109.618a46.999 46.999 0 01-46.091 9.196l-157.358-53.315a47.001 47.001 0 01-31.009-35.319l-32.507-162.933a47 47 0 0115.083-44.515l124.851-109.618z"
            fill="url(#prefix__h)"
          />
        </g>
        <defs>
          <linearGradient
            id="prefix__a"
            x1={-623.016}
            y1={429.386}
            x2={168.257}
            y2={307.881}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E70077" />
            <stop offset={0.974} stopColor="#FC8F0C" />
          </linearGradient>
          <linearGradient
            id="prefix__b"
            x1={-588.8}
            y1={667.74}
            x2={202.474}
            y2={546.236}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E70077" />
            <stop offset={0.974} stopColor="#FC8F0C" />
          </linearGradient>
          <linearGradient
            id="prefix__d"
            x1={-279.084}
            y1={418.219}
            x2={-166.62}
            y2={981.926}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <linearGradient
            id="prefix__f"
            x1={-837.568}
            y1={907.756}
            x2={-78.838}
            y2={633.551}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" stopOpacity={0.54} />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <linearGradient
            id="prefix__h"
            x1={-711.819}
            y1={818.548}
            x2={-50.725}
            y2={579.628}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" stopOpacity={0.54} />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <filter
            id="prefix__c"
            x={-903.987}
            y={0.986}
            width={1362.27}
            height={1398.17}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={63.978} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation={191.936}
              result="effect2_foregroundBlur"
            />
          </filter>
          <filter
            id="prefix__e"
            x={-604.622}
            y={121.955}
            width={781.619}
            height={822.929}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={63.978} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
          </filter>
          <filter
            id="prefix__g"
            x={-525.186}
            y={118.052}
            width={713.71}
            height={748.658}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={63.978} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    pinkRight: (
      <svg
        width={478}
        height={1279}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          ...sides,
        }}
      >
        <path
          d="M554.694-7.343a79.001 79.001 0 0175.081-24.574l417.845 87.874a78.997 78.997 0 0158.82 52.735l132.82 405.801a79 79 0 01-16.26 77.309L937.98 909.729a78.998 78.998 0 01-75.08 24.574l-417.845-87.874a79 79 0 01-58.822-52.735L253.412 387.893a79 79 0 0116.258-77.309L554.694-7.343z"
          fill="url(#prefix__paint0_linear)"
        />
        <g
          style={{
            mixBlendMode: 'hard-light',
          }}
          opacity={0.5}
          filter="url(#prefix__filter0_bf)"
        >
          <path
            d="M576.168 207.582a79.002 79.002 0 0175.081-24.575l278.991 58.674a78.998 78.998 0 0158.822 52.734l88.688 270.95c8.77 26.824 2.58 56.294-16.26 77.309L871.179 854.951a79 79 0 01-75.081 24.574l-278.991-58.673a79 79 0 01-58.822-52.735l-88.683-270.95a78.998 78.998 0 0116.258-77.308l190.308-212.277z"
            fill="url(#prefix__paint1_linear)"
          />
        </g>
        <g
          style={{
            mixBlendMode: 'soft-light',
          }}
          opacity={0.5}
          filter="url(#prefix__filter1_b)"
        >
          <path
            d="M575.956 32.376a79 79 0 0175.081-24.574l234.862 49.392a79.002 79.002 0 0158.822 52.735l74.659 228.093a78.999 78.999 0 01-16.26 77.308L842.912 594.031a79 79 0 01-75.08 24.574L532.97 569.212a78.998 78.998 0 01-58.822-52.734l-74.656-228.093a79 79 0 0116.258-77.309l160.206-178.7z"
            fill="url(#prefix__paint2_linear)"
          />
        </g>
        <g
          style={{
            mixBlendMode: 'soft-light',
          }}
          opacity={0.6}
          filter="url(#prefix__filter2_b)"
        >
          <path
            d="M641.942 12.44a79 79 0 0175.081-24.574l193.152 40.621a79 79 0 0158.822 52.735l61.393 187.585c8.78 26.824 2.59 56.294-16.25 77.309L882.381 493.08a78.998 78.998 0 01-75.08 24.574l-193.152-40.62a79.002 79.002 0 01-58.823-52.735l-61.397-187.585a79 79 0 0116.258-77.309L641.942 12.441z"
            fill="url(#prefix__paint3_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={161.234}
            y1={241.776}
            x2={1170.96}
            y2={-39.586}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E70077" />
            <stop offset={0.974} stopColor="#FC8F0C" />
          </linearGradient>
          <linearGradient
            id="prefix__paint1_linear"
            x1={606.614}
            y1={173.621}
            x2={840.733}
            y2={888.912}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <linearGradient
            id="prefix__paint2_linear"
            x1={-43.08}
            y1={897.126}
            x2={900.52}
            y2={422.327}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" stopOpacity={0.54} />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <linearGradient
            id="prefix__paint3_linear"
            x1={106.482}
            y1={761.543}
            x2={928.658}
            y2={347.841}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" stopOpacity={0.54} />
            <stop offset={1} stopColor="#fff" stopOpacity={0.22} />
          </linearGradient>
          <filter
            id="prefix__filter0_bf"
            x={0.686}
            y={-216.14}
            width={1445.98}
            height={1494.81}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={50} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation={150}
              result="effect2_foregroundBlur"
            />
          </filter>
          <filter
            id="prefix__filter1_b"
            x={237.59}
            y={-179.198}
            width={943.689}
            height={984.803}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={50} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
          </filter>
          <filter
            id="prefix__filter2_b"
            x={338.655}
            y={-187.652}
            width={847.012}
            height={880.824}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation={50} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
  }

  return icons[icon]
}

DemoSvgs.propTypes = {
  icon: PropTypes.string.isRequired,
  sides: PropTypes.object,
}

export default DemoSvgs
